
import Vue from "vue";
import {eventBus, vm} from "@/main";
import store from '@/store';
import axios from "axios";
import Api from "./Api";
import  axiosApi from "./axios";
import { loadScript } from "vue-plugin-load-script";


export default class UserModel {
    static  setAuthHeader(token){
        axiosApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    static unsetAuthHeader() {

        delete axiosApi.defaults.headers.common['Authorization'];
    }

    static get(){


        if(store.getters.USER){
            return store.getters.USER;
        }else if(localStorage.getItem('user')!=null && localStorage.getItem('user').length){
           return  JSON.parse(localStorage.getItem('user'));
        }

        return null;
    }
    static async need_check(){

        try {
            console.log('current hash');
            console.log(window.location.hash);
            if (window.location.hash && window.location.hash.length > 0 && window.location.hash.includes('tgWebAppData')) {
                // http://localhost:8080/redirect?redirect_inner=home#tgWebAppData=query_id%3DAAEX3xULAAAAABffFQsNA_6u%26user%3D%257B%2522id%2522%253A185982743%252C%2522first_name%2522%253A%2522Artem%2522%252C%2522last_name%2522%253A%2522Phpcoder%2522%252C%2522username%2522%253A%2522artemphp%2522%252C%2522language_code%2522%253A%2522ru%2522%257D%26auth_date%3D1650820242%26hash%3D8c2dd522b9b18cd6a6bd9e4aff22e8e37e68cca0744923aca9e04f07f08c603e&tgWebAppThemeParams=%7B%22bg_color%22%3A%22%23ffffff%22%2C%22button_color%22%3A%22%2340a7e3%22%2C%22button_text_color%22%3A%22%23ffffff%22%2C%22hint_color%22%3A%22%23999999%22%2C%22link_color%22%3A%22%23168acd%22%2C%22text_color%22%3A%22%23000000%22%7D

                await loadScript("https://telegram.org/js/telegram-web-app.js");
                console.log(window);
                if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {

                    window.Telegram.WebApp.ready();
                    console.log(window);
                    console.log('hash');
                    console.log(window.location.hash);
                    console.log('telegram redirect log');
                    console.log(window.Telegram.WebApp.initData);

                    var data = await Api.loginByHash(window.Telegram.WebApp.initData);
                    console.log('data user');
                    console.log(data);

                    UserModel.set(data.user,false);
                    return Promise.resolve(true);

                }


            } else if (store.getters.USER != null) {
                UserModel.set(store.getters.USER);
                return Promise.resolve(true);

            } else if (localStorage.getItem('user') != null && localStorage.getItem('user').length > 0) {
                UserModel.set(JSON.parse(localStorage.getItem('user')));
                return Promise.resolve(true);
            } else if (localStorage.getItem('api_token') != null) {

                var data = await Api.loadUserByToken(localStorage.getItem('api_token'));

                return Promise.resolve(true);
            }
        }catch (e){

        }

        return Promise.resolve(false);

    }
    static async check(){




        var result=await UserModel.need_check();








      return   Promise.resolve(result);





    }

    static async set_wait(user){
        UserModel.setAuthHeader(user.api_token);
        localStorage.setItem('api_token', user.api_token);

        localStorage.setItem('user',JSON.stringify(user));
        store.commit('SET_ISAUTH', true);

        store.commit('SET_USER', user);
        store.commit('SET_TOKEN',user.api_token);

        if (user.isdeveloper == 1) {

            store.commit('SET_ISDEVELOPER', true);
        } else {
            store.commit('SET_ISDEVELOPER', false);
        }


        //  eventBus.$emit('user_is_login', user);







        Promise.resolve(user);
    }
    static set(user){
        UserModel.setAuthHeader(user.api_token);
        localStorage.setItem('api_token', user.api_token);

        localStorage.setItem('user',JSON.stringify(user));
        store.commit('SET_ISAUTH', true);

        store.commit('SET_USER', user);
        store.commit('SET_TOKEN',user.api_token);

        if (user.isdeveloper == 1) {

            store.commit('SET_ISDEVELOPER', true);
        } else {
            store.commit('SET_ISDEVELOPER', false);
        }


      //  eventBus.$emit('user_is_login', user);





        eventBus.$emit('user_is_login', user);
        eventBus.$emit('update_user_info', store.getters.ISAUTH, store.getters.ISDEVELOPER);

    }
    static logout(){
        if(localStorage.getItem('api_token')!=null){
            localStorage.removeItem('api_token');
        }
        if(localStorage.getItem('user')){
            localStorage.removeItem('user');
        }

        UserModel.unsetAuthHeader();
        store.commit('SET_TOKEN', null);
        store.commit('SET_ISAUTH', false);
        store.commit('SET_USER', null);


    }
}
